import { render, staticRenderFns } from "./UiSnackbar.vue?vue&type=template&id=64e2044c&"
import script from "./UiSnackbar.vue?vue&type=script&lang=ts&"
export * from "./UiSnackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports